import styled from "styled-components";
import { Modal } from "components/Modal";

export const SuggestedStrategyModalContainer = styled(Modal)`
  .modal-dialog {
    .modal-content {
      padding: 0px 0px 30px 0px;
      .modal-body {
        padding: 0px;
        margin-top: 0px;
      }

      .heading {
        display: flex;
        align-items: center;
        padding: 14px 15px;
        background-color: ${({ theme }) => theme.modal.bg.secondary};
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;

        .back-btn {
          cursor: pointer;
        }

        h2 {
          width: 100%;
          text-align: center;
          color: ${({ theme }) => theme.card.font.tertiary};
          font-size: 20px;
          font-weight: 500;
          margin-bottom: 0px;
        }
      }

      .body {
        padding: 6px 40px 20px 40px;

        .choose-title {
          color: ${({ theme }) => theme.card.font.tertiary};
          font-size: 13px;
          font-weight: 400;
        }

        .icons-wrapper {
          display: flex;
          gap: 10px;
          margin-bottom: 20px;

          .icons {
            width: 35px;
            height: 35px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            cursor: pointer;
            border: 1px solid #e6e6e6;
            justify-content: center;

            &.active {
              border: 1px solid #048af5;
            }

            img {
              width: 21px;
              height: 21px;
            }
          }
        }

        .description-wrapper {
          border-radius: 10px;
          border: 1px solid #048af5;
          padding: 10px 15px;
          background: ${({ theme }) => theme.card.bg.primary};

          .title {
            color: ${({ theme }) => theme.card.font.tertiary};
            font-size: 18px;
            font-weight: 500;
          }

          span {
            color: ${({ theme }) => theme.card.font.secondary};
            font-size: 14px;
            font-weight: 400;
            line-height: 145%; /* 20.3px */
          }
        }

        .button-wrapper {
          display: flex;
          justify-content: flex-end;
          align-items: flex-end;
          gap: 22px;
        }
      }
    }
  }

  @media screen and (max-width: 1000px) {
    .description-col,
    .strategy-card-col {
      width: 100%;
      margin-bottom: 20px;
    }

    .modal-dialog .modal-content .body .button-wrapper {
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
`;
